import type { WorkspaceItem } from '@pn/core/domain/workspace';
import { isNil } from 'lodash-es';

/**
 * Combines existing and incoming workspace items according to the upsert flag:
 * - If upsert is false, only brand new items are added.
 * - If upsert is true, existing items are updated with incoming items.
 */
export function smartCombineItems(
  existingItems: Record<WorkspaceItem['id'], WorkspaceItem>,
  incomingItems: Record<WorkspaceItem['id'], WorkspaceItem>,
  upsert: boolean
): Record<WorkspaceItem['id'], WorkspaceItem> {
  const newItems = Object.fromEntries(
    Object.entries(incomingItems).filter(([id]) => isNil(existingItems[id]))
  );

  if (!upsert) return { ...existingItems, ...newItems };

  const updatedItems = Object.fromEntries(
    Object.entries(existingItems).map(([id, item]) => [
      id,
      isNil(incomingItems[id]) ? item : incomingItems[id],
    ])
  );

  return { ...updatedItems, ...newItems };
}
